export default "__VITE_ASSET__z2ayshoZ__"